export var CommercialFeatureFlags;
(function (CommercialFeatureFlags) {
    CommercialFeatureFlags["Embedding"] = "embedding";
    CommercialFeatureFlags["Scim"] = "scim-token-management";
    CommercialFeatureFlags["AiCopilot"] = "ai-copilot";
    CommercialFeatureFlags["ServiceAccounts"] = "service-accounts";
    CommercialFeatureFlags["OrganizationWarehouseCredentials"] = "organization-warehouse-credentials";
    CommercialFeatureFlags["CustomRoles"] = "custom-roles";
    CommercialFeatureFlags["DirectAccess"] = "direct-access";
    CommercialFeatureFlags["HomepageBuilder"] = "homepage-builder";
    /**
     * Org opt-in: the primary-slot org custom role's scope list fully decides
     * `manage:PersonalAccessToken` instead of inheriting the deployment default.
     */
    CommercialFeatureFlags["PatScopeAuthoritative"] = "pat-scope-authoritative";
})(CommercialFeatureFlags || (CommercialFeatureFlags = {}));
//# sourceMappingURL=commercialFeatureFlags.js.map